import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
import { SectionHeader } from './SectionHeader';
export function Merch() {
  return <section id="merch" className="py-24 md:py-32 px-6 md:px-12 max-w-screen-2xl mx-auto" data-id="element-43">
      <SectionHeader number="05" title="Merch" data-id="element-44" />

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="flex flex-col items-center justify-center text-center py-24 md:py-32 border border-brand-white/10" data-id="element-45">
        <div className="w-20 h-20 rounded-full border border-brand-white/20 flex items-center justify-center mb-8" data-id="element-46">
          <ShoppingBagIcon className="w-8 h-8 text-brand-muted" data-id="element-47" />
        </div>
        <h3 className="font-display text-3xl md:text-5xl text-brand-white uppercase tracking-widest mb-4" data-id="element-48">
          No Merchandise
        </h3>
        <p className="text-brand-muted text-sm md:text-base tracking-widest uppercase max-w-md" data-id="element-49">
          No merchandise at the moment. Check back soon for new drops.
        </p>
      </motion.div>
    </section>;
}